// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2mSpb","paramInput":"JobSimulator_paramInput__1SK95","input":"JobSimulator_input__2JsoY"};